import {config} from '../config';

export default {
    getAgeGateMinAge: () => config.data.login.ageGateMinAge,
    getAgeGateLockTime: () => config.data.login.ageGateLockTime,
};
